import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Alertstripe from "nav-frontend-alertstriper";
import Lenke from "nav-frontend-lenker";
import { Select } from "./../../";
export const _frontmatter = {
  "ingress": "Select viser en meny med valgalternativer og brukes når brukeren skal velge ett av flere alternativer."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#disabled"
          }}>{`Disabled`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#feilmelding"
          }}>{`Feilmelding`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#innhold-mellom-label-og-skjemafelt"
          }}>{`Innhold mellom label og skjemafelt`}</a></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <Alertstripe type="info" mdxType="Alertstripe">
  Dersom du har mindre enn fem valg kan du vurdere å bruke{" "}
  <Lenke href="/components/radio" mdxType="Lenke">radioknapper</Lenke> i stedet, siden de er
  enklere og mer oversiktlige for brukerne.
    </Alertstripe>
    <Example mdxType="Example">
  <Select label="Hvilken land er best om sommeren?" mdxType="Select">
    <option value="">Velg land</option>
    <option value="norge">Norge</option>
    <option value="sverige">Sverige</option>
    <option value="danmark">Danmark</option>
  </Select>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Select label="Hvilken land er best om sommeren?">
  <option value="">Velg land</option>
  <option value="norge">Norge</option>
  <option value="sverige">Sverige</option>
  <option value="danmark">Danmark</option>
</Select>
`}</code></pre>
    <h2 {...{
      "id": "disabled"
    }}>{`Disabled`}</h2>
    <Alertstripe type="advarsel" mdxType="Alertstripe">
  Merk at disabled bør unngås, og at bruken heller bør løses på andre måter, da
  fks kombinert med tydelige feilmeldinger hvis handlingen av en eller annen
  grunn ikke er tillatt. Ler mer om dette på{" "}
  <Lenke href="/accessibility/disabled" mdxType="Lenke">siden vår om `disabled`</Lenke>.
    </Alertstripe>
    <Example mdxType="Example">
  <Select label="Hvilken land er best om sommeren?" disabled mdxType="Select">
    <option value="">Velg land</option>
    <option value="norge">Norge</option>
    <option value="sverige">Sverige</option>
    <option value="danmark">Danmark</option>
  </Select>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Select label="Hvilken land er best om sommeren?" disabled>
  <option value="">Velg land</option>
  <option value="norge">Norge</option>
  <option value="sverige">Sverige</option>
  <option value="danmark">Danmark</option>
</Select>
`}</code></pre>
    <h2 {...{
      "id": "feilmelding"
    }}>{`Feilmelding`}</h2>
    <Example mdxType="Example">
  <Select label="Hvilken land er best om sommeren?" feil="Her er det noe feil" mdxType="Select">
    <option value="">Velg land</option>
    <option value="norge">Norge</option>
    <option value="sverige">Sverige</option>
    <option value="danmark">Danmark</option>
  </Select>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Select label="Hvilken land er best om sommeren?" feil="Her er det noe feil">
  <option value="">Velg land</option>
  <option value="norge">Norge</option>
  <option value="sverige">Sverige</option>
  <option value="danmark">Danmark</option>
</Select>
`}</code></pre>
    <h2 {...{
      "id": "innhold-mellom-label-og-skjemafelt"
    }}>{`Innhold mellom label og skjemafelt`}</h2>
    <p>{`Bruk `}<inlineCode parentName="p">{`description`}</inlineCode>{`-propen for å legge inn egendefinert HTML-innhold mellom labelen og skjemafeltet.`}</p>
    <Example mdxType="Example">
  <Select label="Hvilken land er best om sommeren?" description="En kort beskrivelse av listen" mdxType="Select">
    <option value="">Velg land</option>
    <option value="norge">Norge</option>
    <option value="sverige">Sverige</option>
    <option value="danmark">Danmark</option>
  </Select>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Select
  label="Hvilken land er best om sommeren?"
  description="En kort beskrivelse av listen"
>
  <option value="">Velg land</option>
  <option value="norge">Norge</option>
  <option value="sverige">Sverige</option>
  <option value="danmark">Danmark</option>
</Select>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      